<template>
  <b-card-group>
    <b-card no-body>
      <div class="card-body">
        <div>
          <b-form class="filter-form">
            <b-row>
              <b-col cols="1">
                <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                  <font-awesome-icon icon="times" />
                  {{ $t('Сброс') }}
                </b-button>
              </b-col>
              <filter-input
                :label="$t('Код')"
                :cols="2"
                v-model="form.code"
                v-on:onBlur="search"
              ></filter-input>
            </b-row>
          </b-form>
        </div>
      </div>
    </b-card>
  </b-card-group>
</template>

<script>
import BaseFilter from '@/models/base.filter';

export default {
  name: 'filter-form',
  extends: BaseFilter,
  props: {
    hlaType: Number,
    sourceG: String,
    dest: String,
  },
  data() {
    return {
      form: {
        code: this.code || '',
      },
    };
  },
  methods: {
  },
};
</script>
